var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 30,
    viewBox: "0 0 55 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_4575)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.66882 -0.163086V30.1675H57.9923V-0.163086H-2.66882Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.66882 -0.163086L57.9923 30.1675L-2.66882 -0.163086ZM57.9923 -0.163086L-2.66882 30.1647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6369 32.8801L27.6619 18.3912L-1.31306 32.8801L-4.02417 27.4496L20.8786 14.9996L-4.02417 2.54957L-1.31306 -2.88098L27.6619 11.6079L56.6369 -2.88098L59.3481 2.54957L34.4453 14.9996L59.3481 27.4496L56.6369 32.8801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.66882 -0.163086L57.9923 30.1675L-2.66882 -0.163086ZM57.9923 -0.163086L-2.66882 30.1647Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0868 31.9743L27.6618 17.2576L-1.76323 31.9743L-3.57434 28.3548L23.1423 14.9993L-3.57434 1.64374L-1.76323 -1.97571L27.6618 12.741L57.0868 -1.97571L58.8979 1.64374L32.1812 14.9993L58.8979 28.3548L57.0868 31.9743Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6617 -0.163086V30.1675V-0.163086ZM-2.66882 15.0008H57.9923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7173 30.1647H22.6062V20.0564H-2.66882V9.94525H22.6062V-0.163086H32.7173V9.94525H57.9923V20.0564H32.7173V30.1647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6617 -0.163086V30.1675V-0.163086ZM-2.66882 15.0008H57.9923Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6951 30.1647H24.6284V18.0341H-2.66882V11.9675H24.6284V-0.163086H30.6951V11.9675H57.9923V18.0341H30.6951V30.1647Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_4575"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.3333,
    height: 30,
    fill: "white",
    transform: "translate(0.995117)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.a8c23bc31d0f3f683e2a0bc94fc2f280.svg";
export { ForwardRef as ReactComponent };